import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-send-message",
  "use": "icon-send-message-usage",
  "viewBox": "0 0 19 17",
  "content": "<symbol viewBox=\"0 0 19 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-send-message\">\n<path d=\"M18 8.99988L3.57576 9L1 0.999999L18 8.99988Z\" stroke=\"white\" stroke-linejoin=\"round\" />\n<path d=\"M18 9.00011L3.57576 9L1 16L18 9.00011Z\" stroke=\"white\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol